import script from "./broadband.vue?vue&type=script&setup=true&lang=ts"
export * from "./broadband.vue?vue&type=script&setup=true&lang=ts"

import "./broadband.vue?vue&type=style&index=0&id=bce9be56&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bce9be56"]])

export default __exports__